module.exports = __webpack_public_path__ + "img/bg.fd4d592e.png";